export const SESSION_EXPIRES_AT_HEADER = "x-session-expires-at";
export const SERVER_TIME_HEADER = "x-server-time";

let listener = null;

export const setSessionExpiryListener = (fn) => {
  listener = fn;
};

export const clearSessionExpiryListener = () => {
  listener = null;
};

export const notifyFromResponse = (response) => {
  const headers = response?.headers;
  if (!headers) {
    return;
  }
  const expiresAt = Number(headers[SESSION_EXPIRES_AT_HEADER]);
  const serverTime = Number(headers[SERVER_TIME_HEADER]);
  if (
    listener &&
    Number.isFinite(expiresAt) &&
    expiresAt > 0 &&
    Number.isFinite(serverTime)
  ) {
    listener({ expiresAt, serverTime });
  }
};
